import { Component, OnInit } from '@angular/core';
import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { OrderMenu } from '../../_models/orderMenu';
import { Globals } from '../../_models/globals';
import { Router } from '@angular/router';
import { User } from '../../_models/user';
import { Subject } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../_services/alert.service';
//import { LocalStorageService, SessionStorageService, LocalStorage, SessionStorage } from 'angular-web-storage';
import { ApiIntegration } from '../../_services/api.integration';

@Component({
  selector: 'app-seller-products-list',
  templateUrl: './seller-products-list.component.html',
  styleUrls: ['./seller-products-list.component.scss'],
})
export class SellerProductsListComponent implements OnInit {
  inventoriesMainMenu: OrderMenu[] = [
    { displayName: "All", tabClicked: "all", orderStatus: "ALL", additional: "N" },
    {
      displayName: "Active", tabClicked: "active", orderStatus: "ACTIVE", additional: "N"
    },
    {
      displayName: "Inactive", tabClicked: "inactive", orderStatus: "IN_ACTIVE", additional: "N"
    }
  ];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtInstance: DataTables.Api;
  dtTrigger = new Subject();
  tabClicked: string;
  errorMessage: string;
  productsList: string;
  statusText2: string = "";
  uploadDismissModal: string = "";
  productImage: string = "";
  uploadPopup: string = "";
  selectImport: string = "PRODUCTS";
  totalCount: any;
  products: any;
  files: File[] = [];
  imgUrl = [];
  uploadImage: any;
  productStatus: any = 'ALL';
  totalRecords: number;
  previousStatus = '';
  loading = true;
  displayMsg: string;
  buttonModal: string = 'N';
  constructor(private router: Router, private api: ApiIntegration, private alertService: AlertService, private http: HttpClient, public user: User, private g: Globals) {
    if (this.g.pageTab !== null && this.g.pageTab !== undefined) {
      this.tabClicked = this.g.pageTab;
      let index = this.inventoriesMainMenu.findIndex((d) => d.tabClicked === this.g.pageTab);
      if (index > -1) {
        for (let ol of this.inventoriesMainMenu) {
          if (ol.tabClicked === this.g.pageTab) {
            this.populateTabData(this.g.pageTab, ol.orderStatus);
            this.switchPosition(ol);
          }
        }
      } else {
        this.tabClicked = "all";
        this.populateTabData("all", "ALL");
      }
    } else {
      this.tabClicked = "all";
      this.populateTabData("all", "ALL");
    }
  }

  populateTabData(triggered, productStatus) {
    this.tabClicked = triggered;
    this.productStatus = productStatus;
    if (!this.previousStatus) {
      this.getProductsByStatus(productStatus);
    }
  }

  tabChange() {
    this.errorMessage = "";
    this.g.loaderDisplay = "display";
  }

  openButtonPopUp() {
    this.buttonModal = 'Y';
  }

  closeButtonPopUp() {
    this.buttonModal = 'N';
    this.selectImport = "PRODUCTS";
    this.removeFile();
  }


  switchPosition(om) {
    let index = this.inventoriesMainMenu.indexOf(om);
    om.additional = 'N';
    if (om.displayName !== this.inventoriesMainMenu[5].displayName) {
      this.inventoriesMainMenu[5].additional = 'Y';
    }
    var tmp = 4;
    for (let o of this.inventoriesMainMenu) {
      if (tmp < this.inventoriesMainMenu.length) {
        if (om.displayName !== this.inventoriesMainMenu[tmp].displayName) {
          this.inventoriesMainMenu[tmp].additional = 'Y';
        }
        tmp = tmp + 1;
      }
    }
  }

  createProduct() {
    this.router.navigate(['/admin/sellerProductsCreate']);
  }

  submitImportProduct() {
    //  this.statusText2 = "";
    this.g.loaderDisplay = "display";
    this.uploadDismissModal = "modal";
    this.uploadPopup = "#buttonModal";
    const file = this.productImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadFileToSaveProducts/' + this.user.organizationId + '?accountOwnerId=' + this.user.accountOwnerId + '&sellerId=' + this.user.sellerId, formData, { headers: headerObj }).subscribe(data => {

      if (data['code'] == 200) {
        this.g.loaderDisplay = "";
        this.alertService.success('Product', 'Submitted Successfully');
        this.reset();
        this.closeButtonPopUp();
        this.populateTabData('all', 'ALL');
      } else if (data['code'] == 400) {
        this.g.loaderDisplay = "";
        this.populateTabData('all', 'ALL');
        this.alertService.error('Error', data['message']);
        this.reset();
        return false;
      }
    },

      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.uploadDismissModal = "";
        this.uploadPopup = "#";

      });
  }

  loadorder(event) {
    this.statusText2 = "";
    this.productImage = event.target.files[0];
  }

  getFileName(fileupload): string {
    var filename = fileupload.replace(/^.*[\\\/]/, "");
    return filename;
  }

  getProductsByStatus(status) {
    this.g.loaderDisplay = "display";
    this.api.getAllSellerProductsByStatus(this.user.accountOwnerId, "1", this.user.sellerId, status).subscribe((data: any) => {
      if (data) {
        if (this.productStatus == "ALL") {
          this.totalRecords = data.noOfProducts;
        }
        this.totalCount = data.noOfProducts;
        this.productsList = data.productsList;
      }
      this.g.loaderDisplay = "";
    }, err => {
      this.alertService.error('Error', err);
    });
  }

  reset() {
    this.selectImport = "PRODUCTS";
    this.removeFile();
  }

  removeFile() {
    this.productImage = "";
  }

  ngOnInit() {
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next(true);
    });
  }

  copied(event) {
    if (event.isSuccess) {
    }
  }

  changeStatus(p, index) {
    //this.g.loaderDisplay = "display";
    if (p.status == "ACTIVE") {
      p.status = "IN_ACTIVE";

    } else {
      p.status = "ACTIVE";

    }

    var header1 = new HttpHeaders();
    header1 = header1.append('Content-Type', 'application/json');
    header1 = header1.append('Accept', 'application/json');
    header1 = header1.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/changeProductStatus', {
      "accountOwnerId": this.user.accountOwnerId,
      "productId": p.productId,
      "organizationId": 1,
      "status": p.status
    },
      { headers: header1 }).subscribe(data => {
        if (data['code'] == "200") {
          this.alertService.success('Product', 'Status Updated Successfully');
          if (this.tabClicked == 'active' || this.tabClicked == 'inactive') {
            this.products.splice(index, 1);
            this.rerender();
          } else if (this.tabClicked == 'all') {
            this.rerender();
          }
        } else {
          if (p.status == "ACTIVE") {
            p.status = "IN_ACTIVE";
          } else {
            p.status = "ACTIVE";
          }
          this.alertService.error(data['message']);
        }

        this.g.loaderDisplay = "";
      },
        (err: HttpErrorResponse) => {
          this.g.loaderDisplay = "";

        });

  }


  onSelect(event) {
    console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event) {
    console.log(event);
    this.files.splice(this.files.indexOf(event), 1);
  }

  deleteImage(remove) {
    let index = this.imgUrl.indexOf(remove);
    this.imgUrl.splice(index, 1);
  }

  loadImage(event) {
    for (let i = 0; i < event.target.files.length; i++) {
      this.productImage = URL.createObjectURL(event.target.files[i]);
      this.uploadImage = event.target.files[i];
      this.errorMessage = "";
      this.submitImage();
    }
  }

  submitImage() {
    this.g.loaderDisplay = "display";
    const file = this.uploadImage;
    const formData: FormData = new FormData();
    formData.append('file', file);
    var headerObj = new HttpHeaders();
    //headerObj = headerObj.append('content-Type', 'multipart/form-data');
    headerObj = headerObj.append('Authorization', 'Bearer ' + localStorage.getItem('jwt'));
    this.http.post(environment.apiUrl + 'api/uploadBulkImageToS3', formData, { headers: headerObj }).subscribe(data => {
      this.g.loaderDisplay = "";
      if (data['code'] == 200) {
        this.imgUrl.push(data['message']);
      } else {
        this.imgUrl.push("");
      }
    },
      (err: HttpErrorResponse) => {
        this.g.loaderDisplay = "";
        this.errorMessage = "Upload Image Failed Please Re-try";
      });
    this.imgUrl.push("");
  }

}
